import { ActivatedRouteSnapshot,  Router,  RouterStateSnapshot } from '@angular/router'
import { Injectable } from '@angular/core'
import { AuthService } from '../services/auth.service'
import { SnackbarService } from '../services/snackbar.service'

@Injectable({
  providedIn: 'root'
})
export class EditorGuard {
  constructor(private auth: AuthService, public snackbar:SnackbarService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isAuthenticated = this.auth.isEditor()
    if(!isAuthenticated){ 
      this.router.navigateByUrl('/')
      this.snackbar.showSnackbar('Access denied')
    }
    return isAuthenticated
  }
}